import { useSyncExternalStore } from "react";
import { APP_BREAKPOINT } from "src/constants/layout";

const desktopQuery = `(min-width: ${APP_BREAKPOINT}px)`;

export function useIsDesktop(): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mq = window.matchMedia(desktopQuery);
      mq.addEventListener("change", cb);
      return () => mq.removeEventListener("change", cb);
    },
    () => window.matchMedia(desktopQuery).matches,
    () => false
  );
}
